// extracted by mini-css-extract-plugin
export default {"title-card":"TitleCard_title-card__nBFy0"};